import styled from 'styled-components';

interface HeaderPaddingProps {
  padding?: string;
}

export const HeaderPadding = styled.div<HeaderPaddingProps>`
  padding: ${(props) => props.padding ?? '20px 10px'};
`;

interface ItemPaddingProps {
  padding?: string;
}

export const ItemPadding = styled.div<ItemPaddingProps>`
  padding: ${(props) => props.padding ?? '20px 10px'};
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryBg};
  }
`;
